import React from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { useEffect, useRef, useState, useSyncExternalStore } from "react";
import Menu from "./components/Menu";
import Header from "./components/Header";
import Pen from "./components/Pen";
import { Stage, Layer, Rect, Text, Path } from 'react-konva';
import "./App.css";
import rose from "./image/rose.svg"
import rose1 from "./image/rose2.svg"
import tulip from "./image/tulip.svg"
import periwinkle from "./image/periwinkle.svg"
import daffodil from "./image/daffodil.svg"

function App() {
const canvasRef = useRef(null);
const ctxRef = useRef(null);
const imageRef = useRef(null);
const [show, setShow] = useState(true);
const [show1, setShow1] = useState(true);
const [show2, setShow2] = useState(true);
const [isDrawing, setIsDrawing] = useState(false);
const [lineWidth, setLineWidth] = useState(5);
const [lineColor, setLineColor] = useState("#f72585");
const [lineOpacity, setLineOpacity] = useState(0.1);

const [showResults, setShowResults] = useState(false)
const onClick = () => setShowResults(true)
const [showResults1, setShowResults1] = useState(false)
const onClick1 = () => setShowResults1(true)
const [showResults2, setShowResults2] = useState(false)
const onClick2 = () => setShowResults2(true)

// Initialization when the component
// mounts for the first time
useEffect(() => {
	const canvas = canvasRef.current;
	const ctx = canvas.getContext("2d");
	ctx.lineCap = "round";
	ctx.lineJoin = "round";
	ctx.globalAlpha = lineOpacity;
	ctx.strokeStyle = lineColor;
	ctx.lineWidth = lineWidth;
	ctxRef.current = ctx;
	
}, [lineColor, lineOpacity, lineWidth]);

const setImg= ((imgSrc) => { 
	const canvas = canvasRef.current;
	const ctx = canvas.getContext("2d");
	ctx.clearRect(0, 0, canvas.width, canvas.height);
	var img = new Image();
	img.onload = function() {
		ctx.drawImage(img, 320, 25, 600, 600);
	}
	img.src = imgSrc;
})


// Function for starting the drawing
const startDrawing = (e) => {
	ctxRef.current.beginPath();
	ctxRef.current.moveTo(
	e.nativeEvent.offsetX,
	e.nativeEvent.offsetY
	);
	setIsDrawing(true);
};

// Function for ending the drawing
const endDrawing = () => {
	ctxRef.current.closePath();
	setIsDrawing(false);
};

const draw = (e) => {
	if (!isDrawing) {
	return;
	}
	ctxRef.current.lineTo(
	e.nativeEvent.offsetX,
	e.nativeEvent.offsetY
	);
	
	ctxRef.current.stroke();
};

const setShowimage = (e) => {

}
// const roses = [rose, rose1, tulip];

return (
	<div className="App">
    <Header />
	<div className='flex-container'>
 	 <div>
        <Menu 
          setLineColor={setLineColor}
          setLineWidth={setLineWidth}
          setLineOpacity={setLineOpacity}
        />
		
      </div>
      
    <div className="draw-area">
      <canvas
        onMouseDown={startDrawing}
        onMouseUp={endDrawing}
        onMouseMove={draw}
        ref={canvasRef}
        width={`1300`}
        height={`720px`}
      />

    </div>
    <div>
		{(show || show1 || show2) === false ? (<button className="button" onClick={() =>{setShow(!show); setShow1(!show1); setShow2(!show2) }} width={65}>{"<< Back"}</button>) :null} <br />
		{/* <image>
			
			{ show ? <img onClick={()=>setShow(!show,setImg(rose))} width={65} src={rose}/>:null } {show === false ? <img width={65} src={rose1}/> :null  } <br />
			{ show ? <img onClick={()=>setShow(!show,setImg(rose1))} width={65} src={rose1}/>:null } <br />		
			{ show ? <img onClick={()=>setShow(!show,setImg(tulip))} width={65} src={tulip}/>:null } <br />
		</image> */}
		{/* <image>
			{ (showResults || show)? <img onClick={()=>onClick(setShow(!show,setImg(rose)))} width={65} src={rose}/> : null } <br />
			{ (showResults1 || show)? <img onClick={()=>onClick1(setShow(!show,setImg(rose1)))} width={65} src={rose1}/> : null }<br />
			{ (showResults2 || show)? <img onClick={()=>onClick2(setShow(!show,setImg(tulip)))} width={65} src={tulip}/> : null }<br />
    	</image> */}

		<div>
			{show ? (<button type="button" className="button1" onClick={() => setShow(!show,setImg(rose))} width={65} src={rose}></button>): <img width={65} src={(rose)}/>}
		</div> <br /><br /><br />
		<div>
			{show1 ? (<button type="button" className="button2" onClick={() => setShow1(!show1,setImg(rose1))} width={65} src={rose1} ></button>): <img width={65} src={rose1}/>}
		</div><br /><br /><br />
		<div>
			{show2 ? (<button type="button" className="button3" onClick={() => setShow2(!show2,setImg(tulip))} width={65} src={tulip}></button>): <img width={65} src={tulip}/>} 
		</div>
	</div>
	<Pen />
	</div>
  </div>
);
}

export default App;
